import { useCreateAutomation } from '../queries';
import { useStanRouter } from '@/hooks/useStanRouter';
import { stanNotify } from '@/lib';
import { useAllSetAcknowledgment } from './useAllSetAcknowledgment';
import { DEFAULT_AUTOMATION_DATA } from '../constants';
import { AutomationFormData } from '../types/automation.types';

/**
 * Hook to handle Automations page business logic
 * Manages automation creation
 */
export const useAutomationsPageLogic = () => {
    const { push } = useStanRouter();
    const createMutation = useCreateAutomation();
    const { acknowledged: allSetAcknowledged, acknowledge: handleAcknowledge } = useAllSetAcknowledgment();

    // Handle creating a new automation
    const handleCreateAutomation = async () => {
        try {
            const newAutomation = await createMutation.mutateAsync({
                type: DEFAULT_AUTOMATION_DATA.type,
                status: DEFAULT_AUTOMATION_DATA.status as 'draft',
                data: DEFAULT_AUTOMATION_DATA.data as AutomationFormData['data'],
            });

            push(`/automations?open=${newAutomation.automation_id}`);

            stanNotify({
                type: 'success',
                title: 'Created',
                text: 'Configure your automation below.',
            });
        } catch {
            stanNotify({
                type: 'error',
                title: 'Failed to Create',
                text: 'Please try again.',
            });
        }
    };

    return {
        allSetAcknowledged,
        handleAcknowledge,
        handleCreateAutomation,
    };
};
